import iconDefault from './default.svg?url';
import iconDefault2x from './default@2x.svg?url';
import iconPointer from './pointer.svg?url';
import iconPointer2x from './pointer@2x.svg?url';
import iconGrabbing from './grabbing.svg?url';
import iconGrabbing2x from './grabbing@2x.svg?url';
import iconCrosshair from './crosshair.svg?url';
import iconCrosshair2x from './crosshair@2x.svg?url';
import iconMove from './move.svg?url';
import iconMove2x from './move@2x.svg?url';
import iconNotAllowed from './not-allowed.svg?url';
import iconNotAllowed2x from './not-allowed@2x.svg?url';
import iconResizeEW from './resize-ew.svg?url';
import iconResizeEW2x from './resize-ew@2x.svg?url';
import iconResizeEWRaw from './resize-ew.svg?raw';
import iconResizeEWRaw2x from './resize-ew@2x.svg?raw';
import iconReizeNS from './resize-ns.svg?url';
import iconReizeNS2x from './resize-ns@2x.svg?url';
import iconResizeNESW from './resize-nesw.svg?url';
import iconResizeNESW2x from './resize-nesw@2x.svg?url';
import iconResizeNWSE from './resize-nwse.svg?url';
import iconResizeNWSE2x from './resize-nwse@2x.svg?url';
import iconAllScroll from './all-scroll.svg?url';
import iconAllScroll2x from './all-scroll@2x.svg?url';
import iconWallSplit from './wall-split.svg?url';
import iconWallSplit2x from './wall-split@2x.svg?url';
import iconWallJoin from './wall-join.svg?url';
import iconWallJoin2x from './wall-join@2x.svg?url';
import iconMultiSelect from './multi-select.svg?url';
import iconMultiSelect2x from './multi-select@2x.svg?url';
import iconArrayMatrix from './array-matrix.svg?url';
import iconArrayMatrix2x from './array-matrix@2x.svg?url';
import iconArrayLine from './array-line.svg?url';
import iconArrayLine2x from './array-line@2x.svg?url';
import iconMeasure from './measure.svg?url';
import iconMeasure2x from './measure@2x.svg?url';
import iconAreaDimension from './area-dimension.svg?url';
import iconAreaDimension2x from './area-dimension@2x.svg?url';
import iconLinearDimension from './linear-dimension.svg?url';
import iconLinearDimension2x from './linear-dimension@2x.svg?url';

export default {
  default: iconDefault,
  default2x: iconDefault2x,
  pointer: iconPointer,
  pointer2x: iconPointer2x,
  crosshair: iconCrosshair,
  crosshair2x: iconCrosshair2x,
  move: iconMove,
  move2x: iconMove2x,
  allScroll: iconAllScroll,
  allScroll2x: iconAllScroll2x,
  grabbing: iconGrabbing,
  grabbing2x: iconGrabbing2x,
  resizeEWRaw: iconResizeEWRaw,
  resizeEWRaw2x: iconResizeEWRaw2x,
  notAllowed: iconNotAllowed,
  notAllowed2x: iconNotAllowed2x,
  resizeNS: iconReizeNS,
  resizeNS2x: iconReizeNS2x,
  resizeEW: iconResizeEW,
  resizeEW2x: iconResizeEW2x,
  resizeNWSE: iconResizeNWSE,
  resizeNWSE2x: iconResizeNWSE2x,
  resizeNESW: iconResizeNESW,
  resizeNESW2x: iconResizeNESW2x,
  wallSplit: iconWallSplit,
  wallSplit2x: iconWallSplit2x,
  wallJoin: iconWallJoin,
  wallJoin2x: iconWallJoin2x,
  multiSelect: iconMultiSelect,
  multiSelect2x: iconMultiSelect2x,
  arrayMatrix: iconArrayMatrix,
  arrayMatrix2x: iconArrayMatrix2x,
  arrayLine: iconArrayLine,
  arrayLine2x: iconArrayLine2x,
  measure: iconMeasure,
  measure2x: iconMeasure2x,
  areaDimension: iconAreaDimension,
  areaDimension2x: iconAreaDimension2x,
  linearDimension: iconLinearDimension,
  linearDimension2x: iconLinearDimension2x
};
